module.exports = __webpack_public_path__ + "static/media/viska_mobile_cover.83912a9c.png";